import type { GeneratedSchemaKind } from '@cli-types/core-engine/add-field.js'
import type { SchemaPromptContext } from '@cli-types/next-adapter/commands.js'
import { USER_RELATIONSHIP_TARGET } from '@cli-constants/schema.js'
import { readRelationshipTargetKind } from '@core-engine/schema/add-field/read-relationship-target-kind.js'
import { listSchemaNames } from '@core-engine/schema/schema-reader/list-schema-names.js'
import { fail } from './fail.js'
import { formatKind } from './format-kind.js'
import { promptSelectValue } from './prompt-select-value.js'

export async function promptRelationshipTarget(
  context: SchemaPromptContext,
  kind: GeneratedSchemaKind,
  type: string,
  schemasDir: string
): Promise<string | undefined> {
  if (kind === 'form' || type !== 'relationship') {
    return undefined
  }

  const schemaNames = listSchemaNames(schemasDir).filter(
    (schemaName) => schemaName !== USER_RELATIONSHIP_TARGET
  )
  const targets = schemaNames
    .map((schemaName) => {
      try {
        const targetKind = readRelationshipTargetKind(schemasDir, schemaName)
        return targetKind === 'form'
          ? null
          : { schemaName, targetKind: targetKind as 'entity' | 'single' | 'user' }
      } catch {
        return null
      }
    })
    .filter((target): target is { schemaName: string; targetKind: 'entity' | 'single' | 'user' } =>
      Boolean(target)
    )

  targets.unshift({
    schemaName: USER_RELATIONSHIP_TARGET,
    targetKind: 'user'
  })

  if (targets.length === 0) {
    fail('No Entity or Single schemas are available as relationship targets.')
  }

  return promptSelectValue(
    context,
    'Relationship target',
    targets.map((target) => ({
      value: target.schemaName,
      label: `${target.schemaName} (${formatKind(target.targetKind)})`
    }))
  )
}
